import styled from 'styled-components';

export const Tile = styled.div`
	display: flex;
	flex-direction: column;
`;

type TileRowProps = {
	indent?: boolean;
};
export const TileRow = styled.div<TileRowProps>`
	display: flex;
	justify-content: space-between;
	margin-bottom: 4px;
	${({indent}) => indent && 'margin-left: 24px;'}
`;
